(function () {
  const SELECTORS = {
    root: "[data-mb-hero-info]",
    priceCurrent: "[data-mb-price-current]",
    priceComparisonWrap: "[data-mb-price-comparison]",
    priceOriginal: "[data-mb-price-original]",
    priceSaved: "[data-mb-price-saved]",
    priceDiscount: "[data-mb-price-discount]",
    priceDiscountValue: "[data-mb-price-discount-value]",
    cartCurrency: "[data-mb-cart-currency]",
    freeShipping: "[data-mb-free-shipping]",
    moneyFormatEl: "[data-mb-money-format]",
    installmentPrice: "[data-installment-price]"
  };

  /* INIZIALIZZAZIONE */

  function init(scope = document) {
    scope.querySelectorAll(SELECTORS.root).forEach((root) => {
      if (root.dataset.mbHeroInfoInit === "true") return;

      root.dataset.mbHeroInfoInit = "true";

      document.addEventListener("mb:variant:change", (event) => {
        const variant = event.detail?.variant;
        const variantId = event.detail?.variantId;

        if (!variant || !variantId) return;

        onVariantChange(root, variant, variantId);
      });
    });
  }

  /* CAMBIO VARIANTE */

  function onVariantChange(root, variant, variantId) {
    const moneyFormat = getMoneyFormat();

    updateVariantUrl(variantId);
    updateCurrentPrice(root, variant, moneyFormat);
    updateCompareAndSavings(root, variant, moneyFormat);
    updateFreeShipping(root, variant);
    updateInstallments(variant, moneyFormat);
  }

  /* FORMATO PREZZI */

  function getMoneyFormat() {
    const el = document.querySelector(SELECTORS.moneyFormatEl);
    const raw = el?.textContent?.trim();

    if (raw && raw.startsWith('"')) {
      try {
        return JSON.parse(raw);
      } catch (_) {
        // Usa il contenuto originale se non è JSON valido.
      }
    }

    return raw || "{{amount}}";
  }

  /* PREZZO ATTUALE */

  function updateCurrentPrice(root, variant, moneyFormat) {
    const el = root.querySelector(SELECTORS.priceCurrent);

    if (!el) return;

    const price = toNumberOrZero(variant.price);

    el.textContent = formatMoney(price, moneyFormat);
  }

  /* PREZZO COMPARATIVO E PILL SCONTO */

  function updateCompareAndSavings(root, variant, moneyFormat) {
    const wrap = root.querySelector(SELECTORS.priceComparisonWrap);
    const originalEl = root.querySelector(SELECTORS.priceOriginal);
    const savedEl = root.querySelector(SELECTORS.priceSaved);
    const discountEl = root.querySelector(SELECTORS.priceDiscount);
    const discountValueEl = root.querySelector(
      SELECTORS.priceDiscountValue
    );

    if (!wrap && !originalEl && !savedEl && !discountEl) return;

    const price = toNumberOrZero(variant.price);
    const compare = toNumberOrNull(variant.compare_at_price);

    const hasSaving =
      typeof compare === "number" &&
      compare > 0 &&
      compare > price;

    if (wrap) {
      wrap.style.display = hasSaving ? "" : "none";
    }

    if (!hasSaving) {
      if (originalEl) originalEl.textContent = "";
      if (savedEl) savedEl.textContent = "";
      if (discountEl) discountEl.hidden = true;
      if (discountValueEl) discountValueEl.textContent = "";

      return;
    }

    const saving = compare - price;
    const discountPercent = Math.floor((saving * 100) / compare);

    if (originalEl) {
      originalEl.textContent = formatMoney(compare, moneyFormat);
    }

    if (savedEl) {
      savedEl.textContent = formatMoney(saving, moneyFormat);
    }

    if (discountValueEl) {
      discountValueEl.textContent = `-${discountPercent}%`;
    }

    if (discountEl) {
      discountEl.hidden = discountPercent < 1;
    }
  }

  /* URL VARIANTE */

  function updateVariantUrl(variantId) {
    try {
      const url = new URL(window.location.href);

      url.searchParams.set("variant", String(variantId));

      window.history.replaceState({}, "", url.toString());
    } catch (_) {
      // Non interrompe gli aggiornamenti se l'URL non è modificabile.
    }
  }

  /* PAGAMENTO IN TRE RATE */

  function updateInstallments(variant, moneyFormat) {
    const el = document.querySelector(SELECTORS.installmentPrice);

    if (!el) return;

    const price = toNumberOrZero(variant.price) / 3;

    el.textContent = formatMoney(price, moneyFormat);
  }

  /* SPEDIZIONE: REGOLA GIÀ PRESENTE NEL TEMA */

  function updateFreeShipping(root, variant) {
    const el = root.querySelector(SELECTORS.freeShipping);

    if (!el) return;

    const currency = getCurrency();

    const rates = {
      RON: 5
    };

    const rate = rates[currency] || 1;
    const price = toNumberOrZero(variant.price) / rate;
    const show = price >= 30000;

    el.style.display = show ? "" : "none";
  }

  /* FUNZIONI DI SUPPORTO */

  function getCurrency() {
    const el = document.querySelector(SELECTORS.cartCurrency);
    const raw = el?.textContent;

    if (!raw) return;

    return raw.replace(/"/g, "").trim();
  }

  function toNumberOrZero(value) {
    const number = Number(value);

    return Number.isFinite(number) ? number : 0;
  }

  function toNumberOrNull(value) {
    if (value === null || value === undefined || value === "") {
      return null;
    }

    const number = Number(value);

    return Number.isFinite(number) ? number : null;
  }

  function formatMoney(cents, moneyFormat) {
    const value = toNumberOrZero(cents);

    const formatWithDelimiters = (
      amount,
      precision,
      thousands,
      decimal
    ) => {
      const number = (amount / 100).toFixed(precision);
      const [intPartRaw, decPart] = number.split(".");

      const intPart = intPartRaw.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        thousands
      );

      return precision > 0
        ? `${intPart}${decimal}${decPart}`
        : intPart;
    };

    const tokenMap = {
      amount: () => formatWithDelimiters(value, 2, ",", "."),
      amount_no_decimals: () =>
        formatWithDelimiters(value, 0, ",", "."),
      amount_with_comma_separator: () =>
        formatWithDelimiters(value, 2, ".", ","),
      amount_no_decimals_with_comma_separator: () =>
        formatWithDelimiters(value, 0, ".", ",")
    };

    const match = String(moneyFormat).match(
      /\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator)\s*\}\}/
    );

    if (!match) {
      return (value / 100).toFixed(2);
    }

    const token = match[1];

    const formatted = tokenMap[token]
      ? tokenMap[token]()
      : (value / 100).toFixed(2);

    return String(moneyFormat).replace(match[0], formatted);
  }

  /* AVVIO E RICARICAMENTO SEZIONI */

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();